import { React, useEffect, useState } from "react";
import classes from './ImpactLayer.module.scss'
import RiskQuestion from "./RiskQuestion";

//MUI Imports
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function ImpactLayer({ 
        chosen,
        onPriorityChosen,
        definitions, 
        layerQuestionValues, 
        assessmentPhaseKey, 
        impactLayer, 
        layerKey, 
        layerIndex, 
        layerChoiceTitle, 
        riskOptions, 
        mitigationFields, 
        mitigationBody, 
        fields, 
        onPhaseUpdate, 
        defaultOpen,
        favouriteContent,
        layerIntro }) {

    let [questionValues, setQuestionValues] = useState();

    useEffect(() => {

        if(layerQuestionValues !== undefined && layerQuestionValues !== null){
            if(layerQuestionValues.phases !== undefined){
                if(layerQuestionValues.phases[assessmentPhaseKey] !== undefined){
                    if(layerQuestionValues.phases[assessmentPhaseKey][layerKey] !== undefined){
                        setQuestionValues(layerQuestionValues.phases[assessmentPhaseKey][layerKey].questions)
                    }
                }
            }else{
                setQuestionValues({})
            }
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[assessmentPhaseKey, layerQuestionValues])

    if(chosen){
        return (
            <Box>
                <RiskQuestion
                    key={layerIndex}
                    definitions={definitions}
                    layerKey={layerKey}
                    layerIndex={layerIndex}
                    fields={fields}
                    layerChoiceTitle={layerChoiceTitle}
                    layerIntro={layerIntro}
                    questions={impactLayer.questions}
                    showBlurb={impactLayer.showInstructionBlurb}
                    priorityQuestions={layerQuestionValues.priorityQuestions}
                    questionValues={questionValues}
                    riskOptions={riskOptions}
                    onChosen={onPhaseUpdate}
                    onPriorityChosen={onPriorityChosen}
                    mitigationFields={mitigationFields}
                    mitigationBody={mitigationBody}
                    favouriteContent={favouriteContent}
                    defaultOpen={defaultOpen}
                />
            </Box>
        );
    }else{
        return (

            <Accordion className={`content_wrapper__inner ${classes.ImpactLayer__accordion_container}`}
                disabled
                sx={{
                    backgroundColor:"#ffffff"
                }}
            >
            <AccordionSummary className={`accordion_padding`} expandIcon={<ExpandMoreIcon />} >
                <p className={`gain_content_container__form_container`} dangerouslySetInnerHTML={{__html:`${layerIndex+1}) ${layerChoiceTitle}`}} />
            </AccordionSummary>
        </Accordion>

            
        )
    }

}
export default ImpactLayer